module.exports = __webpack_public_path__ + "assets/img/mecha-df5d0091.png";